export default function Cargando({
  pantalla = false,
  mensaje,
}: {
  pantalla?: boolean;
  mensaje?: string;
}) {
  const contenido = (
    <>
      <div className="girador girador-lg" role="status" aria-label="Cargando" />
      {mensaje && <p className="suave pequeno">{mensaje}</p>}
    </>
  );

  if (!pantalla) return <div className="fila centro g3">{contenido}</div>;

  return (
    <div className="contenedor centro-pantalla" style={{ minHeight: "100dvh" }}>
      {contenido}
    </div>
  );
}
